module.exports = __webpack_public_path__ + "static/media/mercury-is.6e6d429f.svg";